export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_21-e34dcdf644c0cc12b918766ae4a900ec.jpg";